// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__T_J_8","navLink":"navigation_navLink__Ctj_j"};